import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('24', '30', 'NORMAL')};
  margin-bottom: 1rem;
`;

export const StyledSubtitleModal = styled.p`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  margin-bottom: 1rem;
  color: ${COLORS.DARK_ONYX};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'NORMAL')};
      width: 100%;
    }
  }
`;
